/**
 * Get the coordinates of an element relative to the document (cross-browser)
 * @param {HTMLElement} elem
 * @param {boolean} isInModal
 * @returns {Object} top and left position of the element
 */
export const getCoords = (elem: HTMLElement, isInModal: boolean) => {
	const {top, left, bottom, y} = elem.getBoundingClientRect();

	if (isInModal) {
		return {
			top: Math.round(top),
			left: Math.round(left),
			bottom: Math.round(bottom),
			y: Math.round(y)
		};
	}

	const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	const scrollX = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
	const clientTop = document.documentElement.clientTop || document.body.clientTop || 0;
	const clientLeft = document.documentElement.clientLeft || document.body.clientLeft || 0;

	return {
		top: Math.round(top + scrollY - clientTop),
		left: Math.round(left + scrollX - clientLeft),
		bottom: Math.round(bottom + scrollY - clientTop),
		y: Math.round(y)
	};
};
